import { useCallback, useLayoutEffect, useRef, useState } from "react";

export default function useDynamicContainerHeight(padding = 32) {
	const containerRef = useRef<HTMLDivElement>(null);
	// Start with a sensible *bounded* height. Previously this was "" until the
	// first post-paint measurement, so the grid container rendered with no
	// height on the first frame — DataGridPro's absolutely-positioned
	// virtualization scroller then detached into a floating, mis-sized panel
	// (visible as a ghost card overlaying the table on first load).
	const [containerHeight, setContainerHeight] = useState("620px");

	const updateHeight = useCallback(() => {
		if (containerRef.current) {
			const yPosition = containerRef.current.getBoundingClientRect().y;
			const windowHeight = window.innerHeight;
			setContainerHeight(`${windowHeight - yPosition - padding}px`);
		}
	}, [padding]);

	// useLayoutEffect (not useEffect): measure and apply the real height BEFORE
	// the browser paints, so the user never sees the intermediate mis-sized grid.
	useLayoutEffect(() => {
		updateHeight();
		window.addEventListener("resize", updateHeight);
		return () => window.removeEventListener("resize", updateHeight);
	}, [updateHeight]);

	return { containerRef, containerHeight };
}
